function classWithModifiers(r){for(var i=arguments.length,n=Array(i>1?i-1:0),t=1;t<i;t++)n[t-1]=arguments[t];return(n=n.filter(Boolean)).length?(n=n.map(function(i){return r+"--"+i}),r+" "+n.join(" ")):r}export{classWithModifiers};
//# sourceMappingURL=bem.js.map
